import PubSub from "underpub-js";
import Equalizer from "../../../../scripts/classes/Equalizer";

var CtaTwoUpImageLinkItems = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-CtaTwoUpImageLinkItems',
	};

	$.extend(true, this.options, options);

};

CtaTwoUpImageLinkItems.prototype.init = function() {

	var self = this;

	// equalize heading heights
	this.headingEq = new Equalizer( self.options.$el.find(`.${self.options.baseClass}__linkItem__headingWrapper`) );

	this.equalizeHeadings();

	PubSub.subscribe("resized", function(){
		self.equalizeHeadings();
	});

};

CtaTwoUpImageLinkItems.prototype.equalizeHeadings = function() {

	var self = this;

	var breakpoint = window.Breakpoint.value

	if (breakpoint == 'xsmall' || breakpoint == 'small')
	{
		self.options.$el.find(`.${self.options.baseClass}__linkItem__headingWrapper`).css('min-height', 0);
	}
	else
	{
		this.headingEq.equalizeHeights();
	}

};

export default CtaTwoUpImageLinkItems;
